import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import vSelect from 'vue-select'
import {
  BootstrapVue,
  BootstrapVueIcons,
  ToastPlugin,
  ModalPlugin,
} from 'bootstrap-vue';

import VueHtmlToPaper from 'vue-html-to-paper';
import Print from 'vue-printjs';
import VueCompositionAPI from '@vue/composition-api';
import moment from 'moment';
import VueExcelXlsx from 'vue-excel-xlsx';
import VueFullscreen from 'vue-fullscreen';
import CKEditor from 'ckeditor4-vue';
import VueTheMask from 'vue-the-mask'
import '@/directives/index';
import '@/filters/index';
import VueQRCodeComponent from 'vue-qrcode-component';

// 3rd party plugins
import '@/libs/portal-vue';
import '@/libs/toastification';
import '@validations';
import '@/libs/sweet-alerts';

// user define components
import GForm from './components/form/index.vue';
import GField from './components/form/inputs/field.vue';
import GPicker from './components/form/inputs/datePicker.vue';
import GDateTimePicker from './components/form/inputs/dateTimePicker.vue';

const options = {
  name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
  styles: [
    // 'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    `${window.location.origin}/print-style.css`,
  ],
  // timeout: 1000, // default timeout before the print window appears
  autoClose: true,
};

// BSV Plugin Registration
Vue.use(Print);
Vue.use(VueHtmlToPaper, options);
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);
Vue.use(CKEditor);
Vue.use(VueExcelXlsx);
Vue.use(VueTheMask)
// Composition API
Vue.use(VueCompositionAPI);
// Vue.use(VueQRCodeComponent)
Vue.component('qr-code', VueQRCodeComponent);
// fullscreen
Vue.use(VueFullscreen);

// import core styles
require('@core/scss/core.scss');

// import assets styles
require('@/assets/scss/style.scss');

Vue.config.productionTip = false;
Vue.filter('formatDate', (value) => {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY hh:mm');
  }
  return value;
});

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('GForm', GForm)
Vue.component('GField', GField);
Vue.component('GPicker', GPicker);
Vue.component('GDateTimePicker', GDateTimePicker);
Vue.component('v-select', vSelect)
